import { GetterTree } from "vuex";
import { RootState } from "../types";
import { JobStagesInt } from "./types";
export const getters: GetterTree<JobStagesInt, RootState> = {};
